export default "__VITE_ASSET__c92056da__"